import { MouseEvent } from 'react'
import { Typography } from '@mui/material'
// helper
import { handleLink } from '$logic/router/url'
import { showLinkMenu } from '$comp/modals/menus/link-menu'
import { getLinkText } from '$func/link'

export function linkRenderer(key: string, result: string[]) {
  const link = getLinkText(result[0])
  return (
    <Typography
      key={key}
      variant="paragraph3"
      color="secondary"
      sx={{ cursor: 'pointer' }}
      onContextMenu={e => {
        e.stopPropagation()
        e.preventDefault()
        showLinkMenu({ link })
      }}
      onClick={(e: MouseEvent) => {
        e.stopPropagation()
        handleLink(link)
      }}
      dir="ltr"
    >
      {link}
    </Typography>
  )
}
